export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuth();
  await auth.load();
  const { isAuthenticated } = auth;

  // skip API routes
  if (to.path.startsWith('/api') || to.path.startsWith('/impressum')) {
    return;
  }

  if (!isAuthenticated && to.path !== '/auth/login') {
    return navigateTo('/auth/login');
  }

  if (isAuthenticated && to.path === '/auth/login') {
    return navigateTo('/');
  }
});
